import React, { useState } from 'react';
import axios from 'axios';
import { Save, Loader2 } from 'lucide-react';

const API = `${(process.env.REACT_APP_BACKEND_URL || window.location.origin)}/api`;

const DisplaySettings = ({ settings, onSave }) => {
  const [formData, setFormData] = useState({
    logo_url: settings?.logo_url || '',
    logo_position: settings?.logo_position || 'watermark',
    logo_opacity: settings?.logo_opacity || 0.15,
    background_color: settings?.background_color || '#1e3a5f',
    accent_color: settings?.accent_color || '#d4a84b',
    text_color: settings?.text_color || '#ffffff'
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/display/settings`, formData);
      onSave();
      alert('Settings saved!');
    } catch (error) {
      console.error('Error:', error);
    }
    setSaving(false);
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-slate-800">Display Settings</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Church Logo URL</label>
            <input
              type="text"
              value={formData.logo_url}
              onChange={(e) => setFormData({ ...formData, logo_url: e.target.value })}
              placeholder="https://..."
              className="w-full px-4 py-2 border border-slate-200 rounded-xl"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Logo Position</label>
            <select
              value={formData.logo_position}
              onChange={(e) => setFormData({ ...formData, logo_position: e.target.value })}
              className="w-full px-4 py-2 border border-slate-200 rounded-xl"
            >
              <option value="watermark">Watermark (Center)</option>
              <option value="top-left">Top Left</option>
              <option value="top-right">Top Right</option>
              <option value="bottom-left">Bottom Left</option>
              <option value="bottom-right">Bottom Right</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Logo Opacity: {Math.round(formData.logo_opacity * 100)}%
            </label>
            <input
              type="range"
              min="0.05"
              max="0.5"
              step="0.05"
              value={formData.logo_opacity}
              onChange={(e) => setFormData({ ...formData, logo_opacity: parseFloat(e.target.value) })}
              className="w-full"
            />
          </div>
        </div>

        <div className="space-y-4">
          {[
            { label: 'Background Color', key: 'background_color' },
            { label: 'Accent Color (Gold)', key: 'accent_color' },
          ].map(field => (
            <div key={field.key}>
              <label className="block text-sm font-medium text-slate-700 mb-1">{field.label}</label>
              <div className="flex gap-2">
                <input
                  type="color"
                  value={formData[field.key]}
                  onChange={(e) => setFormData({ ...formData, [field.key]: e.target.value })}
                  className="w-12 h-10 rounded border border-slate-200"
                />
                <input
                  type="text"
                  value={formData[field.key]}
                  onChange={(e) => setFormData({ ...formData, [field.key]: e.target.value })}
                  className="flex-1 px-4 py-2 border border-slate-200 rounded-xl"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 disabled:opacity-50"
      >
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
        Save Settings
      </button>
    </div>
  );
};

export default DisplaySettings;
